import React from 'react';

/**
 * 页面切换过渡包装器
 * 为路由切换提供 fade + 轻微上移效果
 */
class PageTransition extends React.Component {
  state = {
    in: false,
  };

  componentDidMount() {
    // 下一帧触发进入动画，确保 DOM 已挂载
    requestAnimationFrame(() => {
      this.setState({ in: true });
    });
  }

  componentWillUnmount() {
    this.setState({ in: false });
  }

  render() {
    const { children } = this.props;
    const isActive = this.state.in;

    return (
      <div
        className={isActive ? 'sj-page-enter-active' : 'sj-page-enter'}
        style={{ willChange: 'opacity, transform' }}
      >
        {children}
      </div>
    );
  }
}

export default PageTransition;
